<template>
  <slot>
    <div mt="3" flex="~ items-center wrap" gap="2">
      <div
        v-if="cityData?.cityName"
        style="border: 1px solid var(--tc-color-primary); color: var(--tc-color-primary); background-color: var(--el-color-primary-light-9);" px="3" h="9" font="300" flex="~ items-center justify-center" rounded="2" class="azgo-haptics-feedback"
        @click="clearCity"
      >
        {{ cityData.cityName }}
        <img src="@/assets/svg/close_green.svg" w="4" h="4" ml="1" />
      </div>
      <div class="azgo-haptics-feedback" b="1 solid #00000014" text="#121212 sm" bg="white" px="3" h="9" font="300" flex="~ items-center justify-center" rounded="2" @click.stop="showPopup = true">
        <NuxtIcon mr="1.5" name="my-icon:location" text="sm #121212" />
        {{ cityData?.cityId ? t('key.search.result.title.change.destination') : t('key.search.result.title.select.destination') }}
      </div>
    </div>
  </slot>

  <BaseAZPopup
    v-model:show="h5Visible"
    :title="t('key.search.result.title.select.destination')"
    height="80vh"
  >
    <BusinessBCitySearch @select-city="citySelectHandler"></BusinessBCitySearch>
  </BaseAZPopup>

  <ElDialog v-model="pcVisible" :title="t('key.search.result.title.select.destination')" width="800px" align-center>
    <div overflow-y="auto" h="50vh">
      <BusinessBCitySearch @select-city="citySelectHandler"></BusinessBCitySearch>
    </div>
  </ElDialog>
</template>

<script lang="ts" setup>
import type { RegionSearchResponse } from '~/apis/back/types'

interface CityData {
  cityId: string
  cityName: string
}

const emit = defineEmits<{
  (event: 'change', city: { cityId: string, cityName: string, cityNameEn: string, countryCode: string } | null): void
}>()

const { t } = useI18n()

const cityData = defineModel<CityData | null>()
const showPopup = defineModel('show', {
  type: Boolean,
  default: false,
})

function citySelectHandler(city: RegionSearchResponse) {
  const newCity = {
    cityId: `${city.cityId}`,
    cityName: city.cityName ?? '',
    cityNameEn: city.cityNameEn ?? '',
    countryCode: city.countryCode ?? '',
  }
  cityData.value = newCity
  emit('change', newCity)
  showPopup.value = false
}

function clearCity() {
  cityData.value = null
  emit('change', null)
}

const isMobile = useMobileByScreen()

const pcVisible = computed({
  get() {
    return showPopup.value && !isMobile.value
  },
  set(val) {
    showPopup.value = val
  },
})

const h5Visible = computed({
  get() {
    return showPopup.value && isMobile.value
  },
  set(val) {
    showPopup.value = val
  },
})
</script>

<style>

</style>
